import {
  useCreateTourPlanMutation,
  useFloorsFacilityCheckpointsQuery,
} from '@/graphql/generated/hooks'
import { CreateTourPlanInput } from '@/graphql/generated/schemas'

export const useCreateTourPlan = (facilityId: string) => {
  const { data } = useFloorsFacilityCheckpointsQuery({
    variables: {
      id: facilityId,
    },
    skip: facilityId === undefined,
    fetchPolicy: 'network-only',
  })
  const [createTourPlan, { loading: isCreateLoading }] =
    useCreateTourPlanMutation()

  const create = async (input: CreateTourPlanInput) => {
    await createTourPlan({
      variables: { input },
      refetchQueries: ['facilityTourPlans'],
    })
  }

  return {
    floorData: data,
    create,
    isCreateLoading,
  }
}
